import { api } from '../api';

export interface BgtTodaySummary {
  date: string;
  source: 'cache' | 'live' | 'empty';
  hasData: boolean;
  testCount: number;
  totalUseTime: number;
  avgScore: number | null;
  yesterdayAvgScore: number | null;
  avgDeltaPct: number | null;
  avgDropped: boolean;
}

export interface BgtContentCard {
  type: string;
  label: string;
  level: number | null;
  todayScore: number | null;
  yesterdayScore: number | null;
  deltaPct: number | null;
  dropped: boolean;
}

export interface BgtTodayDetail {
  summary: BgtTodaySummary;
  contents: BgtContentCard[];
}

export async function getResidentBgtToday(
  residentId: string,
  date?: string,
): Promise<BgtTodayDetail> {
  const res = await api.get<BgtTodayDetail>(`/residents/${residentId}/bgt/today`, {
    params: date ? { date } : undefined,
  });
  return res.data;
}
